import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';

interface VizAxisLabelProps {
  children: string;
  isVertical?: boolean;
}

const VizAxisLabel = ({ children, isVertical }: VizAxisLabelProps) => (
  <Box
    sx={{
      alignSelf: 'center',
      px: isVertical ? 0.25 : 1,
      py: isVertical ? 0.75 : 0.5,
      borderRadius: (theme) => `${theme.shape.borderRadiusSm}px`,
      backgroundColor: 'background.default',
    }}
  >
    <Typography
      variant="micro1"
      color="text.tertiary"
      sx={isVertical ? { writingMode: 'vertical-rl', transform: 'rotate(180deg)' } : undefined}
    >
      {children}
    </Typography>
  </Box>
);

export default VizAxisLabel;
